var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationBar',{attrs:{"notification-type":_vm.modifiers,"nomargin":_vm.isNomargin}},[_c('ScRichText',{attrs:{"tag":"span","field":_vm.fields.bodytext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }